const FEEDBACK_API_URL = process.env.GATSBY_SAGE_API_URL

const buildUrl = (path) => {
  if (!FEEDBACK_API_URL) {
    throw new Error('Feedback API URL is not configured.')
  }

  return `${FEEDBACK_API_URL}${path}`
}

export const retrieveClient = async (token) => {
  if (!token) {
    throw new Error('Missing feedback token.')
  }

  const response = await fetch(buildUrl(`/retrieve-client/?token=${encodeURIComponent(token)}`), {
    method: 'GET',
  })

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}))
    throw new Error(errorBody?.message || 'Unable to load your feedback form. Please contact your Outsmart Insight lead.')
  }

  return response.json()
}

export const submitFeedback = async (payload) => {
  if (!payload?.token) {
    throw new Error('Missing feedback token.')
  }

  const response = await fetch(buildUrl('/submit-feedback/'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}))
    throw new Error(errorBody?.message || 'We could not submit your feedback. Please try again.')
  }

  return response.json()
}

export const submitProjectFeedback = async (payload) => {
  if (!payload?.token) {
    throw new Error('Missing feedback token.')
  }

  const response = await fetch(buildUrl('/submit-project-feedback/'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}))
    throw new Error(errorBody?.message || 'We could not submit your project feedback. Please try again.')
  }

  return response.json()
}

